import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InventoryWidgetTable from './InventoryWidgetTable/InventoryWidgetTable';
import { filterInventory, getWarningsNumber } from '../../../../utils/utils';
import { useInventorySubscription } from '../useInventorySubscription';
import { InventoryViewMode } from '../inventory.types';
export const useStyles = makeStyles(() => ({
    contentContainer: {
        padding: '20px 10px 0 10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100% - 35px)',
        overflowY: 'auto',
    },
}));
export const InventoryWidgetL = (props) => {
    const { modalParams } = props;
    const classes = useStyles();
    const inventory = useInventorySubscription();
    const inventoryViewMode = (modalParams === null || modalParams === void 0 ? void 0 : modalParams.inventoryViewMode) || InventoryViewMode.CRITICAL;
    const [viewMode, setViewMode] = useState(inventoryViewMode);
    const filteredInventory = useMemo(() => filterInventory(inventory, viewMode), [inventory, viewMode]);
    const { criticalCount, earlyCount } = getWarningsNumber(inventory);
    return (React.createElement("div", { className: classes.contentContainer }, !!inventory && (React.createElement(InventoryWidgetTable, { filteredInventory: filteredInventory, viewMode: viewMode, criticalCount: criticalCount, earlyCount: earlyCount, setViewMode: setViewMode }))));
};
//# sourceMappingURL=InventoryWidgetL.js.map